module.exports = __webpack_public_path__ + "img/plus-24px-dark.34e7c47.svg";